import { Component, Input, OnInit } from '@angular/core';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { CLIENT_CONFIG } from '@config/config';

@Component({
  selector: 'app-notification-component',
  templateUrl: './notification-component.component.html',
  styleUrls: ['./notification-component.component.scss'],
})
export class NotificationComponent implements OnInit {
  public clientConfig = CLIENT_CONFIG;
  public disableSuprSendNotification: boolean = false;
  @Input() user_distinct_id: string;
  @Input() user_subscriberId: string;

  constructor(public durationService: DurationRangeService) {}

  ngOnInit(): void {
    this.disableSuprSendNotification = this.durationService?.disableSuprsendNotification;
  }
}
